import { connect } from 'react-redux';
import imageDefault from '../../../assets/images/svg/ic-image-default.svg';
import { formatPrice } from '../../../services/helpers/Helper';

const Products = (props) => {
   const { carts } = props;
   const { cartItems } = carts;
   return (
      <div className="list-cart-container">
         <div className="title-container">
            <div className="svg-next-icon icon-title icon-car">
            </div><span className="title">Sản phẩm ({cartItems.length})</span>
         </div>
         <div className="product-wrapper">
            {cartItems.map((item, index) => {
               return (
                  <div id="0" className="product-item-container" key={index}>
                     <div>
                        <img src={item.product_image ? item.product_image : imageDefault} className="image-product" />
                     </div>
                     <div className="info-product-container">
                        <div className="header-product-container">
                           <div className="title-container">
                              <span title={item.product_name} className="title-product">
                                 {item.product_name}
                              </span>
                           </div>
                           <div className="icon-close">
                              <button disabled="" type="button" className="app-btn app-btn-link app-btn-pd-none app-btn-size-small">
                                 <div className="svg-next-icon ic-close">
                                 </div>
                              </button>
                           </div>
                        </div>
                        <div className="price-container">
                           <span className="price">{formatPrice(item.price)} ₫</span>
                           <span className="quantity-bull">.</span>
                           <span className="quantity">Số lượng: {formatPrice(item.quantity)}</span>
                        </div>
                     </div>
                  </div>
               )
            })}
         </div>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { carts } = state;
   return {
      carts
   };
};

export default connect(mapStateToProps, {
})(Products);
